import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const netlify = defineConnector({
  identifier: "netlify",
  name: "Netlify",
  tagLine: "Web hosting and deployment",
  keywords: "jamstack static sites cdn functions edge deploys forms",
  logo,
  protocol: "http",
  tags: ["engineering"],
  defaultUrlPattern: () => "https://api\\.netlify\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get your Netlify personal access token",
      items: [
        {
          kind: "markdown",
          content:
            "In your Netlify dashboard, go to **User Settings > Applications > Personal access tokens** and create a new token.",
        },
      ],
    },
    {
      title: "Enter your access token",
      items: [
        {
          kind: "input",
          label: "Personal access token",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.netlify.com/api/v1/user",
  },
});
